import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Container from './Container';
import Loader from './Loader';
import Text from './Text';

const defaultRender = data => {
  const { header, children } = data;
  return (
    <>
      {typeof header === 'string' ? (
        <Container
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          padding="0 16px"
          fontWeight="600"
          minHeight="55px"
          borderBottom={theme => `1px solid ${theme.border.border300}`}
        >
          <Text
            width="120px"
            flex="1 0 auto"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            fontWeight="bold"
          >
            {header}
          </Text>
        </Container>
      ) : (
        header
      )}
      <Container flex="1 1 100%">{children}</Container>
    </>
  );
};

const Loading = () => (
  <Container
    display="flex"
    flex="1"
    justifyContent="center"
    alignItems="center"
    width="100%"
    height="100%"
  >
    <Loader width="150px" />
  </Container>
);

const Panel = forwardRef(
  ({ render, children, header, loading, ...props }, ref) => (
    <Container
      margin="small"
      display="flex"
      flexDirection="column"
      ref={ref}
      border="1px solid"
      borderColor="border300"
      borderRadius="0.5em"
      backgroundColor="white"
      {...props}
    >
      {render({
        header,
        children: loading ? <Loading /> : children,
      })}
    </Container>
  )
);

Panel.propTypes = {
  render: PropTypes.func,
  children: PropTypes.node,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  loading: PropTypes.bool,
};

Panel.defaultProps = {
  render: defaultRender,
  children: null,
  header: null,
  loading: false,
};

export default Panel;
